import axios from 'axios';

const isLoginRequest = (url) => {
  if (!url) return false;
  return url.includes('/api/user/auth/login');
};

axios.interceptors.request.use(
  (config) => {
    if (!isLoginRequest(config.url)) {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Token ${token}`;
      }
    }
    return config;
  },
  (err) => Promise.reject(err)
);

export default axios;
